import utcToZonedTime from 'date-fns-tz/utcToZonedTime';

export function getUtcDate(date, timezone) {
  const serverTimezone = process.env.DEFAULT_SERVER_TIMEZONE;

  return utcToZonedTime(date, timezone ?? serverTimezone);
}
